import { render, staticRenderFns } from "./ProtocolListSetting.vue?vue&type=template&id=9b68fd90&scoped=true"
import script from "./ProtocolListSetting.vue?vue&type=script&lang=js"
export * from "./ProtocolListSetting.vue?vue&type=script&lang=js"
import style0 from "./ProtocolListSetting.vue?vue&type=style&index=0&id=9b68fd90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b68fd90",
  null
  
)

export default component.exports